// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","267":"categories","690":"items","700":"home-login","831":"lists"}[chunkId] + "." + {"177":"1e8fb25c","267":"58525a61","690":"49da3d6d","700":"85fdf492","831":"71006a5a"}[chunkId] + ".css";
};